import { validateCompliance } from "utils";

export const indirectSupplierFormFields = [
  {
    label: 'Στην επεξεργασία προσωπικών δεδομένων και την άντληση - διασταύρωση στοιχείων από τρίτες πηγές.',
    id: 'terms1',
    name: 'terms1',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι τηρεί τους όρους του παρόντος Προγράμματος.',
    id: 'terms2',
    name: 'terms2',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι διαθέτει δηλώνει προς πώληση μόνο τα προϊόντα που τηρούν τα ελάχιστα χαρακτηριστικά του Προγράμματος',
    id: 'terms3',
    name: 'terms3',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι αποφεύγει αθέμιτες πρακτικές και κάθε ενέργεια εκμετάλλευσης των όρων του Προγράμματος.',
    id: 'terms4',
    name: 'terms4',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'Ότι τηρεί τους κανόνες δημοσιότητας του Προγράμματος. Κάνει χρήση του λογότυπου του Προγράμματος, ακολουθεί τις κατευθυντήριες οδηγίες που περιγράφονται στην επίσημη διαδικτυακή πύλη και να παραπέμπει σε αυτή, σε κάθε σχετική με το Πρόγραμμα διαφήμιση.',
    id: 'terms5',
    name: 'terms5',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: <span>Να <strong>ενημερώνεται</strong>, σε τακτά χρονικά διαστήματα, για την <strong>πορεία</strong> της αίτησής του, για τις <strong>ενέργειες</strong> που απαιτείται να πραγματοποιήσει και τις <strong>προθεσμίες</strong> που τίθενται από το Πρόγραμμα, μέσω της διεύθυνσης ηλεκτρονικού ταχυδρομείου που δηλώνει κατά την υποβολή της αίτησής του στο Πληροφοριακό Σύστημα. Η έγκαιρη ανάγνωση απεσταλμένων μηνυμάτων ηλεκτρονικού ταχυδρομείου είναι σημαντική για την επιτυχή υλοποίηση του έργου και αποτελεί αποκλειστική <strong>ευθύνη</strong> του.</span>,
    id: 'terms6',
    name: 'terms6',
    type: 'checkbox',
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
      { required: true, message: <div className='ComplianceErrorMessage'>Το πεδίο είναι υποχρεωτικό</div> },
      () => ({
        validator(_, value) {
          return validateCompliance(value);
        },
      }),
    ],
    asterisk: true,
  },
];

export const indirectSupplierFieldNames = indirectSupplierFormFields.map(it => it.name);
